import { chipColours } from '../../lib/colour';
import { useTheme } from '../../theme/ThemeProvider';
import type { Labelled } from '../../vocab/VocabularyProvider';

/**
 * The coloured status pill from screenshot 8. `status_def.colour` is admin-editable data, so the
 * text colour is derived from it (see lib/colour.ts) rather than assumed to be white.
 */
export function StatusChip({
  status,
  trailing,
  className = '',
}: {
  status: Labelled | null;
  trailing?: React.ReactNode;
  className?: string;
}) {
  const { resolved } = useTheme();
  const colours = chipColours(status?.colour, resolved === 'dark');
  const unresolved = status !== null && !status.resolved;

  return (
    <span
      style={{ backgroundColor: colours.background, color: colours.foreground }}
      title={unresolved ? `Status code ${status.code} — label unavailable` : undefined}
      className={`inline-flex max-w-full items-center gap-1 rounded-[3px] px-1.5 py-0.5 text-[11px] font-bold tracking-wide uppercase ${className}`}
    >
      <span className="truncate">{status ? status.label : 'No status'}</span>
      {unresolved ? <span aria-hidden="true">?</span> : null}
      {trailing}
    </span>
  );
}
